import React, { FC, useState, useEffect } from 'react';
import { CommentDtoType } from '../../../types/dto/CommentDtoType';
import { CommentListItem } from './CommentListItem';
import { EntityType } from '../../../types/dto/EntityType';
import { toast } from 'react-toastify';

type CommentRepliesProps = {
  className?: string, 
  linkedId: number,
  userId?: number,
  parentId: number,
  type: EntityType,
  isUpdate: boolean,
  onUpdate: (value: boolean) => void,
  onAdded: (newComment: CommentDtoType) => any
};

const CommentReplies: FC<CommentRepliesProps> = ({
  className,
  linkedId,
  userId,
  parentId,
  type,
  isUpdate,
  onUpdate,
  onAdded
}) => {
  const [comments, setComments] = useState<CommentDtoType[]>();

  const fetchReplies = async (abortController: AbortController) => {
    const signal = abortController.signal;
    try {
      await fetch('/api/comments', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          linkedId: linkedId,
          commentId: parentId,
          type: type,
          userId: userId
        }),
        signal: signal
      })
        .then(response => response.json())
        .then(data => {
          setComments(data?.comments);
          onUpdate(false);
        })
    } catch (error) {
      toast.success('Something went wrong, please try again later', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
    }
  };

  const commentChangedHandler = (changedItem: CommentDtoType) => {
    setComments(comments.map(t => t.id === changedItem.id ? changedItem : t));
  };

  const commentDeletedHandler = (deletedItem: CommentDtoType) => {
    setComments(comments.filter(t => !(t.id === deletedItem.id)));
  };

  useEffect(() => {
    const abortController = new AbortController();

    fetchReplies(abortController);

    return () => abortController.abort();
  }, [isUpdate]);

  return (
      <div className={`${className} flex flex-col text-white text-sm pl-12`}>
      <div className="max-h-96 overflow-y-scroll comment-section">
        {comments?.map((comment) => (
          <CommentListItem
            key={comment.id}
            type={type}
            comment={comment}
            linkedId={linkedId}
            isCommentReplies={true}
            onAdded={onAdded}
            onChanged={commentChangedHandler}
            onDeleted={commentDeletedHandler}
          />
        ))}
      </div>
    </div>
  )
};

export default CommentReplies;
